import React from 'react';
import styles from './styles.module.less';

export function EnIcon({ className }) {
  return (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 33.31 20.92"
      className={className}
    >
      <polygon className={styles.st0} points="33.3,0.05 33.3,20.9 33.29,20.91 0.03,20.91 0.03,0.05" />
      <polygon
        className={styles.st1}
        points="33.3,18.73 33.3,20.9 33.29,20.91 29.83,20.91 19.62,14.5 18.6,13.86 17.39,13.11 16.99,12.85
      15.76,12.08 15.3,11.79 14.92,11.56 14.15,11.07 13.9,10.92 13.52,10.68 9.9,8.4 8.27,7.38 0.03,2.22 0.03,0.05 0.06,0.01
      0.12,0.05 3.49,0.05 13.9,6.57 14.92,7.21 15.19,7.38 16.83,8.4 16.99,8.51 17.61,8.9 18.6,9.52 18.77,9.63 19.62,10.16
      20.46,10.68 22.69,12.08 24.33,13.11"
      />
      <polygon
        className={styles.st2}
        points="33.3,20.84 33.31,20.92 31.08,20.91 19.62,13.72 18.64,13.11 18.6,13.08 17.61,12.46 17.02,12.08
      15.93,11.4 14.92,10.77 14.78,10.68 14.15,10.29 13.9,10.13 11.15,8.4 9.52,7.38 0.03,1.43 0.03,0 0.06,0.01 0.12,0.05
      11.83,7.38 13.45,8.4 13.9,8.68 14.92,9.33 15.3,9.57 15.93,9.96 17.08,10.68 18.6,11.63 18.77,11.74 19.32,12.08 19.62,12.27
      20.95,13.11"
      />
      <polygon
        className={styles.st1}
        points="33.3,0.46 33.3,2.63 25.71,7.38 24.08,8.4 20.46,10.68 19.62,11.2 18.77,11.74 18.6,11.84
      18.21,12.08 17.61,12.46 16.99,12.85 16.58,13.11 14.92,14.15 13.9,14.79 4.14,20.91 0.03,20.91 0.03,19.14 9.65,13.11
      11.28,12.08 13.52,10.68 13.9,10.45 14.15,10.29 14.92,9.8 15.3,9.57 16.99,8.51 17.15,8.4 18.6,7.5 18.78,7.38 19.62,6.86
      30.49,0.05 33.04,0.05"
      />
      <polygon
        className={styles.st2}
        points="33.21,0.57 22.34,7.38 20.71,8.4 19.62,9.09 18.77,9.63 18.6,9.73 17.08,10.68 15.93,11.4
      15.3,11.79 14.92,12.04 14.84,12.08 13.9,12.68 13.21,13.11 0.78,20.91 0.03,20.91 0.03,19.93 10.91,13.11 12.54,12.08
      13.9,11.23 14.15,11.07 14.78,10.68 14.92,10.59 15.93,9.96 17.61,8.9 18.4,8.4 18.6,8.28 19.62,7.64 20.03,7.38 31.73,0.05
      32.89,0.05 33.3,0.05 33.3,0.5"
      />
      <rect y="7.38" className={styles.st3} width="33.31" height="5.72" />
      <rect y="8.4" className={styles.st2} width="33.31" height="3.68" />
      <rect x="14.92" y="0.05" className={styles.st4} width="3.68" height="20.86" />
      <polygon
        className={styles.st3}
        points="18.59,13.11 19.61,13.11 19.61,20.91 13.89,20.91 13.89,13.11 14.91,13.11 14.91,7.38 13.89,7.38
      13.89,0.05 19.61,0.05 19.61,7.38 18.59,7.38"
      />
      <rect x="14.89" y="0.05" className={styles.st2} width="3.72" height="20.86" />
    </svg>
  );
}
